import React from 'react'
import { cn } from '../../lib/utils'

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('text-sm font-medium text-gray-700 dark:text-gray-200', className)}
    {...props}
  />
))

Label.displayName = 'Label'

export { Label }
